module.exports = __webpack_public_path__ + "static/img/77-1.79ff374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/77-1.jpg
// module id = lkrT
// module chunks = 0